module.exports = __webpack_public_path__ + "files/f9aad3964199f55227f81c9122b390a3.png";